import { OptionsStripDto } from "../../maintenance/option/OptionsStripDto";

export class ForkliftFilterDto {

    public accessControlId: number | undefined | null = null;
    public addressId: number | undefined | null = null;
    public gateId: number | null = null;
    public periodFilter: OptionsStripDto | null = null;
    public selectedPeriodId: string | null = null;
    public searchText: string | null = null;

    public static build(accessControlId: number | undefined | null, addressId: number | undefined | null, gateId: number | null): ForkliftFilterDto {
        const dto = new ForkliftFilterDto();
        dto.accessControlId = accessControlId;
        dto.addressId = addressId;
        dto.gateId = gateId;
        dto.periodFilter = OptionsStripDto.buildStandardPeriodFilter();
        dto.selectedPeriodId = dto.periodFilter.getActualSelected().optionId;
        return dto;
    }

    public static equals(a: ForkliftFilterDto, b: ForkliftFilterDto): boolean {
        if (a === b)
            return true;
        if (!a || !b)
            return false;
        return a.accessControlId === b.accessControlId
            && a.addressId === b.addressId
            && a.gateId === b.gateId;
    }

}
